// Espelha as validações da spec 159 para dar retorno imediato; a validação real é do servidor.
// Devolve { campo: CHAVE } com chaves de `COMMERCIAL_GOALS.VALIDATION`.
export const validateGoalForm = (form, isEditing) => {
  const errors = {};
  const target = Number(form.targetValue);

  if (!(target > 0)) errors.targetValue = 'TARGET_POSITIVE';
  else if (form.goalType === 'conversion_rate' && target > 100) {
    errors.targetValue = 'CONVERSION_MAX';
  }

  if (!form.startDate || !form.endDate) errors.dates = 'DATES_REQUIRED';
  else if (form.endDate < form.startDate) errors.dates = 'END_BEFORE_START';

  if (!isEditing && form.scopeType === 'user' && !form.assignedUserIds.length) {
    errors.users = 'USERS_REQUIRED';
  }

  if (!isEditing && form.goalType === 'product_sales' && !form.productId) {
    errors.product = 'PRODUCT_REQUIRED';
  }

  return errors;
};

const toIsoDate = date =>
  [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, '0'),
    String(date.getDate()).padStart(2, '0'),
  ].join('-');

// Atalhos só preenchem as datas: mês, trimestre ou ano civil que contém `today`.
export const getPeriodShortcut = (shortcut, today = new Date()) => {
  const year = today.getFullYear();
  const month = today.getMonth();
  const [firstMonth, monthCount] = {
    month: [month, 1],
    quarter: [Math.floor(month / 3) * 3, 3],
    year: [0, 12],
  }[shortcut];

  return {
    startDate: toIsoDate(new Date(year, firstMonth, 1)),
    endDate: toIsoDate(new Date(year, firstMonth + monthCount, 0)),
  };
};
